import { ModelDef } from '../index'

const model: ModelDef = {
  tableName: 'files',
  tableLabel: 'ファイル',
  tableComment: '',
  timestamps: true,
  defaultSort: { key: 'createdAt', order: 'desc' },
  columns: {
    name: {
      label: 'ファイル名',
      type: 'STRING',
      validate: { notEmpty: true },
      searchable: true,
    },
    filePath: {
      label: 'URL',
      type: 'STRING',
      inputComponent: () =>
        // @ts-ignore
        import('../../../firebase_nuxt/FireORMNuxtSharedResources/components/inputImageUploader.vue'),
      validate: { notEmpty: true },
    },
    category: {
      label: 'カテゴリ',
      type: 'STRING',
      selectionsWithAlgoFacetsColName: 'category',
      facet: { showOnSearch: true },
    },
    _tags: {
      label: 'タグ',
      type: 'MULTISELECT',
      selectionsWithAlgoFacetsColName: '_tags',
      facet: { showOnSearch: true },
    },
    作成日時: { type: 'STRING', editable: false },
    更新日時: { type: 'STRING', editable: false },
    // fileUrl: {
    //   type: 'FILE_PREVIEW',
    //   // @ts-ignore
    //   inputComponent: () => import('../modelServices/inputFilePreview.vue'),
    //   visibleOnIndex: false,
    //   // editable: false,
    // },
  },
  // showOnSettingMenu: true,
  showOnMainmenu: false,
  showOnSettingMenu: true,
  // algoSettings: {
  //   sorting: ['desc(timestamp)'],
  // },
  shouldCreateHistoryData: ({ before, after }) => false,
}

export default model
